import styled from 'styled-components'

export const PreviewContainer = styled.div`
  /* margin: 30px 0; */
`
